import React from "react";
import {Navigation} from "./Navigation";
import {Footer} from "./Footer";
import {useNavigate} from "react-router-dom";
import {Button, ButtonGroup} from "react-bootstrap";
import {Item} from "../core/types";
import {bg_2} from '../image/backgrounds'

type PageProps = {
    title?: string,
    children: JSX.Element | JSX.Element[],
    type?: 'default' | 'admin'
    allowPrev?: boolean
    allowEdit?: boolean
    allowDelete?: boolean
    handleDelete?: () => void
}

export const Page = (props: PageProps) => {

    const navigate = useNavigate()

    const buildButtons = (): Item => {
        if (props.type !== 'admin') { return null; }

        const buttons = []

        if (props.allowPrev) {
            buttons.push(<Button key={'goback'} variant={'light'} onClick={() => navigate(-1)}>Retour</Button>)
        }

        if (props.allowEdit) {
            buttons.push(<Button key={'edit'} variant={'primary'} onClick={() => navigate(`edit`)}>Modifier</Button>)
        }

        if (props.allowDelete && props.handleDelete) {
            buttons.push(<Button key={'edit'} variant={'danger'} onClick={() => props.handleDelete!()}>Supprimer</Button>)
        }

        if (buttons.length === 0) { return null; }

        return (
            <div className={'d-flex justify-content-center gap-3'}>
                <ButtonGroup>
                    { buttons }
                </ButtonGroup>
            </div>
        )
    }

    return (
        <div>
            <Navigation type={props.type || 'default'}/>
            <div
                style={{
                    height: 'calc(100vh - 176px)',
                    overflowY: 'auto',
                    position: 'relative'
            }}
            >
                <div
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        backgroundImage: `url(${bg_2})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        backgroundRepeat: 'no-repeat',
                        opacity: 0.5,
                        zIndex: -1,
                    }}
                />
                {
                    props.title && <div className={'d-flex-center position-relative'}>
                        <div
                            className={`ff-netto bg-light text-primary text-center m-0 fs-3 w-100`}
                            // className={`ff-netto bg-primary swatch-primary text-center m-0 fs-3 w-100`}
                            style={{
                                lineHeight: '5rem',
                                height: '5rem',
                                display: 'inline-block',
                                padding: '0 2rem',
                                whiteSpace: "nowrap",
                                boxShadow: "0 .5rem 1rem rgba(0,0,0,.3)"
                            }}
                        >
                            {props.title}
                        </div>
                    </div>
                }
                {props.children}
                { buildButtons() }
            </div>
            <Footer/>
        </div>
    )
}